<div class="booker-details mt-5">
    <div class="">
        <form [formGroup]="profile">
            <div class="row">

                <!-- Label name needs to be the same as formControlName so it can be translated dynamically -->

                <div class="col-12 col-md-6">

                    <label for="first-name">{{"pr.firstName"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="first-name" pInputText  type="text" formControlName="firstName" required [attr.data-testid]="'booking-first-name'">
                        <app-profile-validation-icon [control]="profile.get('firstName')"></app-profile-validation-icon>
                    </p-iconfield>

                </div>
                <div class="col-12 col-md-6">
                    <label for="last-name">{{"pr.lastName"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="last-name" pInputText  type="text" formControlName="lastName" required [attr.data-testid]="'booking-last-name'">
                        <app-profile-validation-icon [control]="profile.get('lastName')"></app-profile-validation-icon>
                    </p-iconfield>
                </div>
            </div>
            @if (settings.get('profile.askForCompanyName')) {
                <div class="row">
                    <div class="col-12">
                        <label for="company-name">{{"pr.companyName"|translate}}</label>
                        <input id="company-name" pInputText type="text" formControlName="companyName" [attr.data-testid]="'booking-company-name'">
                    </div>
                </div>
            }
            <div class="row">
                <div class="col-12 col-md-8">
                    <label for="email">{{"pr.emailAddress"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="email" pInputText  type="text" formControlName="emailAddress" required [attr.data-testid]="'booking-email'">
                        <app-profile-validation-icon [control]="profile.get('emailAddress')"></app-profile-validation-icon>
                    </p-iconfield>
                </div>
                <div class="col-12 col-md-4">
                    <label for="phone-number">{{"pr.phoneNumber"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="phone-number" #iti  pInputText  type="text" formControlName="phoneNumber" required [attr.data-testid]="'booking-phone'">
                        <input type="hidden" name="_phone_full" formControlName="_phone_full">
                        <app-profile-validation-icon [control]="profile.get('phoneNumber')"></app-profile-validation-icon>
                    </p-iconfield>

                </div>
            </div>
            <div class="row">
                <div class="col-12 my-2">
                    <p-checkbox formControlName="marketingPermission" binary="true" inputId="marketingPermission" />
                    &nbsp;<label for="marketingPermission">{{"pr.marketingPermission"|translate}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-8">
                    <label for="address">{{"pr.address"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="address" pInputText  type="text" formControlName="address" required [attr.data-testid]="'booking-address'">
                        <app-profile-validation-icon [control]="profile.get('address')"></app-profile-validation-icon>
                    </p-iconfield>
                </div>
                <div class="col-12 col-md-4">
                    <label for="zip-code">{{"pr.zipCode"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="zip-code" pInputText  type="text" formControlName="zipCode" required [attr.data-testid]="'booking-zip'">
                        <app-profile-validation-icon [control]="profile.get('zipCode')"></app-profile-validation-icon>
                    </p-iconfield>
                </div>
            </div>
            <div class="row">

                <div class="col-12 col-md-4">
                    <label for="city">{{"pr.city"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    <p-iconfield>
                        <input id="city" pInputText  type="text" formControlName="city" required [attr.data-testid]="'booking-city'">
                        <app-profile-validation-icon [control]="profile.get('city')"></app-profile-validation-icon>
                    </p-iconfield>
                </div>
                <div class="col-12 col-md-4">
                    <label for="country">{{"pr.country"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                    @if (countries) {
                        <p-iconfield>
                            <p-select
                            id="country"
                            formControlName="country"
                            [filter]="true"
                            filterBy="name"
                            [options]="countries"
                            optionLabel="name"
                            optionValue="alpha2"
                            [placeholder]="'pr.selectACountry' | translate"
                            [attr.data-testid]="'booking-country'"
                            >
                                <ng-template #dropdownicon>
                                    <p-button icon="pi pi-check" aria-label="Toggle dropdown" [rounded]="true" [text]="true">
                                        <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                    </p-button>
                                </ng-template>
                            </p-select>
                            <app-profile-validation-icon [control]="profile.get('country')" class="for-select"></app-profile-validation-icon>
                        </p-iconfield>
                    }
                </div>
                <div class="col-12 col-md-4">
                    <label for="eta">{{"pr.eta"|translate}}</label>

                    <p-iconfield>
                        <p-select
                        id="eta"
                        formControlName="eta"
                        [filter]="false"
                        filterBy="name"
                        [options]="etaValues"
                        optionLabel="value"
                        optionValue="value"
                        [attr.data-testid]="'booking-eta'"
                        >
                            <ng-template #dropdownicon>
                                <p-button icon="pi pi-check" aria-label="Toggle dropdown" [rounded]="true" [text]="true">
                                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                </p-button>
                            </ng-template>
                        </p-select>
                        <!-- <app-profile-validation-icon [control]="profile.get('eta')" class="for-select"></app-profile-validation-icon> -->
                    </p-iconfield>
<!--                     <p-datepicker inputId="calendar-timeonly" formControlName="eta" hourFormat="24" [stepMinute]="settings.get('profile.etaStep') ?? '30'" [timeOnly]="true"  required=""/>
 -->                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <label for="message">{{"pr.message"|translate}}</label>
                    <textarea id="message"
                        rows="3"
                        cols="30"
                        pTextarea
                        formControlName="message"
                        [attr.data-testid]="'booking-message'">
                    </textarea>
                </div>
            </div>

        </form>

        @if (externalLogin) {
            <div class="row">
                <div class="col-12 col-md-10">
                    <p-message>{{'pr.externalLoginProfilePrefilled'|translate}}</p-message>
                </div>
                <div class="col-12 col-md-2 d-flex align-items-center justify-content-end">
                    <p-button (click)="logout()">{{'pr.logout'|translate}}</p-button>
                </div>
            </div>
        }
    </div>
</div>
